export default {
  title:
    'Earn reward progress automatically - use the card you already shop with',
}
